<script>
import tableMixin from '@/helpers/mixins/table' 

export default {
    props: {
        url: String,
        columns: Array,
        
    },
    mixins: [ tableMixin ],
    methods:{
        rowStyleClassFn(row) {
            return 'className-'+row.id;
        },
    }
};
</script>

<template>
    <div class="row">
        <div class="col-12">
            <vue-good-table
                mode="remote"
                styleClass="vgt-table bordered condensed"
                :line-numbers="true" 
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                :row-style-class="rowStyleClassFn"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                <div>Yükleniyor</div>
                </template>
                    <template
                    slot="table-row"
                    slot-scope="props"
                    >
                    <span
                        v-if="props.column.field === '#'"
                        class="text-nowrap"
                    >
                       <slot name="prop-slot" :row="props.row"/>
                    </span>
                </template>
            </vue-good-table>

            <slot name="context-slot" />
        </div>
    </div>
</template>